module.exports = __webpack_public_path__ + "static/img/10004 (4).6e48dff.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/10000/10004 (4).webp
// module id = 7mr4
// module chunks = 14